import {
  formatTaskCodeWithUid,
  parseTaskCode,
} from "../../../../Project/plant/PlantTaskPage/TaskList/components/taskCodeUtils";

/** Extract code prefix (first two segments) from code, e.g. "2.1.1" → "2.1" */
export const getCodePrefix = (code) => {
  if (!code || typeof code !== "string") return null;
  const parts = String(code).trim().split(".").filter(Boolean);
  if (parts.length < 2) return parts[0] || null;
  return parts.slice(0, 2).join(".");
};

/** Check if a code starts with any existing prefix (invalid for new group) */
export const startsWithExistingPrefix = (code, existingPrefixes) => {
  if (!code || !Array.isArray(existingPrefixes)) return false;
  const normalized = String(code).trim();
  return existingPrefixes.some(
    (p) => p && (normalized === p || normalized.startsWith(`${p}.`)),
  );
};

export const buildGroupNameToPrefix = (tasks = []) => {
  const taskCodes = (tasks || []).map((t) => t.taskCode).filter(Boolean);
  const map = new Map();
  taskCodes.forEach((tc) => {
    const { code, groupName: gn } = parseTaskCode(tc);
    if (gn && code) {
      const p = getCodePrefix(code);
      if (p && !map.has(gn)) map.set(gn, p);
    }
  });
  return map;
};

export const buildExistingGroupNames = (tasks = []) => {
  const taskCodes = (tasks || []).map((t) => t.taskCode).filter(Boolean);
  const names = new Set();
  taskCodes.forEach((tc) => {
    const { groupName: gn } = parseTaskCode(tc);
    if (gn) names.add(gn);
  });
  return Array.from(names).sort();
};

export const computeTaskCode = ({
  wbsMode,
  wbsSuffix,
  wbsFull,
  autoCodePrefix,
  groupName,
  selectedUid,
}) => {
  let code = "";
  if (wbsMode === "existing") {
    const suffix = String(wbsSuffix || "")
      .trim()
      .replace(/^\.+/, "");
    const prefix = autoCodePrefix;
    if (prefix && suffix) code = `${prefix}.${suffix}`;
  } else {
    code = String(wbsFull || "").trim();
  }

  const gn = String(groupName || "").trim();
  const uid = String(selectedUid ?? "").trim();
  if (!code || !gn || !uid) return "";
  return formatTaskCodeWithUid({ code, groupName: gn, uid });
};

export const validateNewGroupCode = (wbsMode, wbsFull, existingCodePrefixes) => {
  if (wbsMode !== "new" || !wbsFull) return null;
  const code = String(wbsFull).trim();
  if (!code) return null;
  const segments = code.split(".").filter(Boolean);
  if (segments.length !== 2) {
    return "Group code must have exactly 2 segments (e.g. 2.8).";
  }
  if (startsWithExistingPrefix(code, existingCodePrefixes)) {
    return "This code starts with an existing group. Use 'Use existing group' instead.";
  }
  return null;
};

export const EMPTY_NEW_TASK = {
  task: "",
  taskCode: "",
  type: "engineering",
  startDate: "",
  endDate: "",
  estimatedTime: 0,
  resourceId: "",
};
